// used in:
// GET /login
// GET /admin-saas/login
// GET /user-dashboard/login
// TODO: to redo for type & subtype
export default {
    'SEND-LOGIN': {
        actionType: 'toast',
        message: {
            fr: 'Une erreur est survenue lors de la connexion.',
            en: 'An error occurred while logging in.',
        },
    },
};
